<div style="display: flex; justify-content: center; margin: 0 auto">
	<mat-dialog-content style="padding-top: 20px">
		<form [formGroup]="form">
			<h1 mat-dialog-title class="notification-title" style="padding-bottom: 10px">
				{{ 'sales.configurator.title' | translate }}
			</h1>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'sales.configurator.model' | translate }}
				</mat-label>
				<input maxlength="255" matInput [formControl]="model" />
			</mat-form-field>

			<div class="dialog-container">
				<mat-form-field appearance="outline" class="dialog">
					<mat-label class="mat-body-1">
						{{ 'sales.configurator.height' | translate }}
					</mat-label>
					<input type="number" min="0" oninput="value = !!value && Math.abs(value) >= 0 ? Math.abs(value) : null" matInput [formControl]="height" />
				</mat-form-field>

				<div class="spacer"></div>

				<mat-form-field appearance="outline" class="dialog">
					<mat-label class="mat-body-1">
						{{ 'sales.configurator.width' | translate }}
					</mat-label>
					<input type="number" min="0" oninput="value = !!value && Math.abs(value) >= 0 ? Math.abs(value) : null" matInput [formControl]="width" />
				</mat-form-field>
			</div>
		</form>
		<button mat-flat-button color="primary" (click)="calculateModel()" style="width: 100%">
			{{ 'sales.configurator.calcbtn' | translate }}
			<mat-icon svgIcon="acies_calculator" style="margin-left: 8px"></mat-icon>
		</button>
	</mat-dialog-content>
</div>
<div style="display: flex; justify-content: center; margin: 20px auto 10px auto">
	<mat-label>{{ 'sales.configurator.parameters' | translate }}: {{ queryParams }}</mat-label>
</div>
<div style="display: flex; justify-content: center; margin: 0 auto">
	<mat-label>{{ 'sales.configurator.user' | translate }}: {{ user }}</mat-label>
</div>
